import { useEffect, Dispatch, useState, SetStateAction } from 'react';
import {
  getUserRolesAdmin,
  IDeaNumUser,
  IError,
  IUser,
  ResponseCSOSHeaders,
  useUserContext,
} from '../common';
import { left, right, fold, map as emap } from 'fp-ts/lib/Either';
import { pathOr } from 'rambda';
import { compose as lcompose } from 'lodash/fp';

export const useUserRoleSearch = ({
  email,
  deaNumber,
  serialNumber,
}: {
  email: string | null;
  deaNumber: string | null;
  serialNumber: string | null;
}) => {
  const { user } = useUserContext();

  const [userRoles, setUserRoles] = useState<IDeaNumUser[]>([]);

  useEffect(() => {
    lcompose(
      emap(handleRequest(setUserRoles)),
      startRequest
    )({
      user,
      email,
      deaNumber,
      serialNumber,
    });
  }, [user, email, deaNumber, serialNumber]);

  return {
    userRoles,
  };
};

const handleRequest =
  (dispatch: Dispatch<SetStateAction<IDeaNumUser[]>>) =>
  ({
    hR,
    email,
    deaNumber,
    serialNumber,
  }: {
    hR: ResponseCSOSHeaders;
    email: string | null;
    deaNumber: string | null;
    serialNumber: string | null;
    firstName: string | null;
    lastName: string | null;
  }) => {
    getUserRolesAdmin(hR)({
      email,
      deaNumber,
      serialNumber,
    }).then(
      fold<IError, IDeaNumUser[], void>(
        console.error, // TODO
        dispatch
      )
    );
  };

const startRequest = lcompose(
  ({
    user,
    email,
    deaNumber,
    serialNumber,
  }: {
    user: IUser;
    email: string | null;
    deaNumber: string | null;
    serialNumber: string | null;
  }) =>
    pathOr(void 0, 'icam.headers')(user) !== void 0 &&
    (email !== null ||
      (deaNumber !== null && deaNumber.length === 9) ||
      serialNumber !== null)
      ? right({
          deaNumber,
          email,
          serialNumber,

          hR: pathOr(void 0, 'icam.headers')(user),
        })
      : left(void 0)
);
